var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2774 3.08403C13.5071 3.2372 13.5692 3.54764 13.416 3.7774L7.41603 12.7774C7.33293 12.902 7.19834 12.9829 7.04927 12.9976C6.9002 13.0124 6.75237 12.9595 6.64645 12.8536L2.64645 8.85361C2.45118 8.65834 2.45118 8.34176 2.64645 8.1465C2.84171 7.95124 3.15829 7.95124 3.35355 8.1465L6.92229 11.7152L12.584 3.2227C12.7372 2.99294 13.0476 2.93085 13.2774 3.08403Z",
    fill: "#116427"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/iconCheck.e3f106ce657827455de3044088c21b04.svg";
export { ForwardRef as ReactComponent };